// extracted by mini-css-extract-plugin
export default {"foot":"Footer_foot__ILZQ-","design":"Footer_design__pZYEL","after":"Footer_after__UcNwM"};